import { useContext } from 'react';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import type { WorldReadyProps } from '@client/utils/localeHelper';

const useWorldReadyContext = () => useContext<WorldReadyProps>(WorldReadyContext);

export { useWorldReadyContext, WorldReadyProps };
